import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => {
  const styles: StyleRules = {
    root: {
      maxWidth: '100%',
      marginTop: '1.25rem',
    },
    cardContent: {
      padding: '1.5rem',
      '@media(max-width: 600px)': {
        padding: '1.5rem 0.5rem',
      },
    },
    mainTitle: {
      fontSize: '1.25rem',
    },
    paragraph: {
      fontSize: '0.875rem',
    },
    btnNewPage: {
      background: '#0D2772',
      color: '#fff',
      height: '3rem',
      maxWidth: '16.875rem',
      margin: '1rem 0',
      textTransform: 'none',
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      '@media(max-width: 600px)': {
        maxWidth: 'initial',
        width: '100%',
      },
      '&:hover': {
        background: '#0d2772b8',
        color: '#fff',
        transition: '0.3s',
      },
    },
    cardLink: {
      padding: 0,
      paddingTop: '1.5rem',
      '&:last-child': {
        paddingBottom: 0,
      },
    },
    linksSubtitle: {
      paddingBottom: '1rem',
    },
    contentLink: {
      width: '18.06rem',

      '@media(max-width: 600px)': {
        width: '100%',
      },
    },
  };

  return styles;
});
